document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('bf-product-modal');
  if (!modal) return;

  const dialog = modal.querySelector('.bf-product-modal__dialog');
  const qtyInput = document.getElementById('bf-modal-qty');
  const qtyMinus = document.getElementById('bf-modal-qty-minus');
  const qtyPlus = document.getElementById('bf-modal-qty-plus');
  const addToCartBtn = document.getElementById('bf-modal-add');
  const viewProductLink = document.getElementById('bf-modal-link');
  const recsContainer = document.getElementById('bf-modal-recommendations');
  const recsPrev = document.getElementById('bf-recs-prev');
  const recsNext = document.getElementById('bf-recs-next');
  
  let currentProduct = null;
  let currentVariantId = null;
  let lastContext = { collectionHandles: [], productType: '' };

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    const currency = window.shopCurrency || 'USD';
    try {
      return value.toLocaleString('en-US', { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' });
    } catch {
      return `$${value.toFixed(2)}`;
    }
  }

  function openModalShell() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bf-modal-open');
    if (dialog) dialog.focus();
  }

  function closeModalShell() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bf-modal-open');
    currentProduct = null;
    currentVariantId = null;
    if (viewProductLink) {
      viewProductLink.setAttribute('href', '#');
    }
  }

  function updateRecsArrows() {
    if (!recsContainer || !recsPrev || !recsNext) return;

    const canScroll = recsContainer.scrollWidth > recsContainer.clientWidth + 2;
    if (!canScroll) {
      recsPrev.classList.remove('is-visible');
      recsNext.classList.remove('is-visible');
      return;
    }

    recsPrev.classList.add('is-visible');
    recsNext.classList.add('is-visible');

    const atStart = recsContainer.scrollLeft <= 2;
    const atEnd =
      recsContainer.scrollLeft + recsContainer.clientWidth >= recsContainer.scrollWidth - 2;

    recsPrev.classList.toggle('is-disabled', atStart);
    recsNext.classList.toggle('is-disabled', atEnd);
  }

  async function openProductModal(handle, context = null) {
    if (!handle) return;

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Product not found');
      
      const product = await response.json();
      currentProduct = product;
      // Persist context (best-effort)
      lastContext = normalizeContext(context, product);
      const selectedVariant =
        (product.variants && product.variants.find((v) => v.available)) ||
        (product.variants && product.variants[0]);
      currentVariantId = selectedVariant ? selectedVariant.id : null;

      // Track view_item event for modal product view
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: window.shopCurrency || 'USD',
          value: parseFloat(product.price || 0) / 100,
          items: [{
            item_id: String(product.id || ''),
            item_name: product.title || '',
            item_brand: product.vendor || '',
            item_category: product.product_type || product.type || '',
            item_variant: selectedVariant && selectedVariant.title && selectedVariant.title !== 'Default Title' ? selectedVariant.title : '',
            price: parseFloat(product.price || 0) / 100,
            quantity: 1,
            index: 0
          }]
        }
      });

      const modalImg = document.getElementById('bf-modal-image');
      if (modalImg) {
        modalImg.src = product.featured_image;
        modalImg.alt = product.title;
      }
      
      const titleEl = document.getElementById('bf-modal-title');
      const vendorEl = document.getElementById('bf-modal-vendor');
      const priceEl = document.getElementById('bf-modal-price');
      const compareEl = document.getElementById('bf-modal-compare');

      if (titleEl) titleEl.textContent = product.title || '';
      if (vendorEl) vendorEl.textContent = product.vendor || '';
      if (priceEl) priceEl.textContent = formatMoney(product.price);

      if (compareEl && product.compare_at_price > product.price) {
        compareEl.textContent = formatMoney(product.compare_at_price);
        compareEl.style.display = 'inline';
      } else {
        if (compareEl) compareEl.style.display = 'none';
      }

      // Link to the full product page (always /products/<handle>)
      if (viewProductLink) {
        viewProductLink.setAttribute('href', `/products/${handle}`);
      }

      qtyInput.value = 1;
      fetchRecommendations(product.id, lastContext);
      openModalShell();
      requestAnimationFrame(updateRecsArrows);

    } catch (error) {
      console.error('Error opening product modal:', error);
    }
  }

  async function fetchRecommendations(productId, context) {
    const recContainer = recsContainer;
    if (!recContainer) return;

    recContainer.innerHTML = '';
    
    try {
      const recommended = await getShopifyRecommendations(productId, 4);
      const products = (recommended && recommended.length)
        ? recommended
        : await getFallbackProducts(productId, 4, context);

      recContainer.innerHTML = '';
      products.forEach((prod) => {
        const price = formatMoney(getProductPriceCents(prod));
        const image = getProductImageUrl(prod);
        const title = prod.title || '';
        const handle = prod.handle || '';

        const item = document.createElement('div');
        item.className = 'bf-rec';
        
        item.innerHTML = `
          <div class="bf-rec__img">
            ${image ? `<img src="${image}" alt="${escapeHtml(title)}">` : ''}
          </div>
          <div class="bf-rec__meta">
            <div class="bf-rec__title">${escapeHtml(title)}</div>
            <div class="bf-rec__price">${price}</div>
          </div>
          <button type="button" class="bf-rec__cart" aria-label="Add ${escapeHtml(title)} to cart">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          </button>
        `;

        item.addEventListener('click', (e) => {
          if (e.target.closest('.bf-rec__cart')) return;
          if (!handle) return;
          e.preventDefault();
          e.stopPropagation();
          openProductModal(handle, lastContext);
        });

        const recCartBtn = item.querySelector('.bf-rec__cart');
        recCartBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();

          let variantId = getFirstVariantId(prod);
          if (!variantId && handle) {
            try {
              variantId = await fetchFirstVariantIdByHandle(handle);
            } catch (_) {}
          }
          if (!variantId) return;

          recCartBtn.disabled = true;
          const originalHTML = recCartBtn.innerHTML;
          recCartBtn.innerHTML = '<svg class="bf-spinner" viewBox="0 0 50 50" style="width:16px;height:16px;animation:bf-rotate 2s linear infinite;"><circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5" style="stroke-dasharray:90,150;stroke-dashoffset:0;stroke-linecap:round;"></circle></svg>';

          try {
            await addItemToCart(variantId, 1);
            recCartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
            setTimeout(() => {
              recCartBtn.innerHTML = originalHTML;
              recCartBtn.disabled = false;
            }, 2000);
          } catch (err) {
            console.error(err);
            recCartBtn.innerHTML = originalHTML;
            recCartBtn.disabled = false;
          }
        });

        recContainer.appendChild(item);
      });
      requestAnimationFrame(updateRecsArrows);
    } catch (error) {
      recContainer.innerHTML = '';
      updateRecsArrows();
    }
  }

  async function getShopifyRecommendations(productId, limit = 4) {
    const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`, {
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to fetch recommendations');
    const data = await response.json();
    const products = (data && data.products) ? data.products : [];
    return Array.isArray(products) ? products : [];
  }

  async function getFallbackProducts(excludeProductId, limit = 4, context) {
    const ctx = normalizeContext(context, currentProduct);

    // 1) Best: same collection (excluding "all")
    for (const handle of (ctx.collectionHandles || [])) {
      if (!handle || handle === 'all') continue;
      try {
        const fromCollection = await getProductsFromCollection(handle, excludeProductId, limit);
        if (fromCollection.length) return fromCollection;
      } catch (_) {}
    }

    // 2) Next best: same product_type from /collections/all/products.json
    if (ctx.productType) {
      try {
        const byType = await getProductsByType(ctx.productType, excludeProductId, limit);
        if (byType.length) return byType;
      } catch (_) {}
    }

    // 3) Last resort: anything (never empty)
    return await getAnyProducts(excludeProductId, limit);
  }

  function normalizeContext(context, product) {
    const ctx = context && typeof context === 'object' ? context : {};
    const productType = (ctx.productType || (product && (product.product_type || product.type)) || '').trim();
    const collectionHandles = Array.isArray(ctx.collectionHandles)
      ? ctx.collectionHandles
      : (typeof ctx.collectionHandles === 'string' ? ctx.collectionHandles.split(',') : []);
    return {
      productType,
      collectionHandles: collectionHandles.map((s) => String(s || '').trim()).filter(Boolean),
    };
  }

  async function getProductsFromCollection(collectionHandle, excludeProductId, limit) {
    const response = await fetch(`/collections/${collectionHandle}/products.json?limit=${Math.max(limit * 3, 24)}`, {
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to fetch collection products');
    const data = await response.json();
    const products = (data && data.products) ? data.products : [];
    const filtered = (Array.isArray(products) ? products : []).filter((p) => String(p.id) !== String(excludeProductId));
    return filtered.slice(0, limit);
  }

  async function getProductsByType(productType, excludeProductId, limit) {
    const response = await fetch(`/collections/all/products.json?limit=100`, {
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to fetch products for type filter');
    const data = await response.json();
    const products = (data && data.products) ? data.products : [];
    const filtered = (Array.isArray(products) ? products : [])
      .filter((p) => String(p.id) !== String(excludeProductId))
      .filter((p) => String(p.product_type || '').toLowerCase() === String(productType || '').toLowerCase());
    return filtered.slice(0, limit);
  }

  async function getAnyProducts(excludeProductId, limit) {
    const response = await fetch(`/collections/all/products.json?limit=${Math.max(limit * 3, 24)}`, {
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to fetch fallback products');
    const data = await response.json();
    const products = (data && data.products) ? data.products : [];
    const filtered = (Array.isArray(products) ? products : []).filter((p) => String(p.id) !== String(excludeProductId));
    return filtered.slice(0, limit);
  }

  function getProductImageUrl(prod) {
    return (
      prod.featured_image ||
      (Array.isArray(prod.images) && prod.images[0] && (prod.images[0].src || prod.images[0])) ||
      ''
    );
  }

  function getProductPriceCents(prod) {
    // recommendations/products.json returns cents in prod.price
    if (typeof prod.price === 'number') return prod.price;
    // collections/all/products.json returns strings in variants[0].price
    const variant = Array.isArray(prod.variants) ? prod.variants[0] : null;
    const priceStr = variant && variant.price != null ? String(variant.price) : '0';
    const n = Number.parseFloat(priceStr);
    return Number.isFinite(n) ? Math.round(n * 100) : 0;
  }

  function getFirstVariantId(prod) {
    const v = Array.isArray(prod.variants) ? prod.variants[0] : null;
    return v && v.id ? v.id : null;
  }

  async function fetchFirstVariantIdByHandle(handle) {
    const response = await fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error('Failed to fetch product for variant id');
    const p = await response.json();
    const v = p && Array.isArray(p.variants) ? (p.variants.find((vv) => vv.available) || p.variants[0]) : null;
    return v && v.id ? v.id : null;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = String(text || '');
    return div.innerHTML;
  }

  async function addItemToCart(variantId, quantity) {
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
    });
    
    if (!response.ok) throw new Error('Failed to add to cart');

    let itemCount = 0;
    try {
      const cartResponse = await fetch('/cart.js');
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        itemCount = cart.item_count || (cart.items && cart.items.length) || 0;
      }
    } catch (_) {}

    const cartLinks = document.querySelectorAll('.header__cart-link');
    cartLinks.forEach((link) => {
      if (window.getComputedStyle(link).position === 'static') link.style.position = 'relative';
      let badge = link.querySelector('.header__cart-badge');
      if (itemCount > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-badge';
          link.appendChild(badge);
        }
        badge.textContent = itemCount;
        badge.style.display = 'flex';
        badge.style.visibility = 'visible';
        badge.style.opacity = '1';
      } else if (badge) {
        badge.remove();
      }
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount } }));
    const cartDrawerOpenBtn = document.querySelector('[data-cart-drawer-open]');
    if (cartDrawerOpenBtn) cartDrawerOpenBtn.click();
  }

  // Track mouse position to detect drag vs click
  let mouseDownPos = null;
  const DRAG_THRESHOLD = 10; // pixels

  document.addEventListener('mousedown', function (e) {
    mouseDownPos = { x: e.clientX, y: e.clientY };
  }, true);

  document.addEventListener('click', function (e) {
    const quickAdd = e.target.closest('.quick-add-btn');
    if (quickAdd) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    // Allow explicitly opted-out links (important for SVG clicks inside anchors)
    const clickPath = typeof e.composedPath === 'function' ? e.composedPath() : [];
    const isOptedOut = clickPath.some((node) => {
      if (!node || typeof node !== 'object') return false;
      // Element or SVGElement
      if (typeof node.getAttribute === 'function') {
        if (node.getAttribute('data-bf-ignore-product-modal') !== null) return true;
        if (node.id === 'bf-modal-link') return true;
      }
      return false;
    });
    if (isOptedOut) {
      // Force the modal's external-link icon to open a new tab reliably
      const modalLink = clickPath.find(
        (node) => node && typeof node === 'object' && node.id === 'bf-modal-link'
      );
      if (
        modalLink &&
        typeof modalLink.getAttribute === 'function' &&
        typeof modalLink.href === 'string' &&
        modalLink.href &&
        modalLink.getAttribute('href') !== '#'
      ) {
        e.preventDefault();
        e.stopPropagation();
        try {
          window.open(modalLink.href, '_blank', 'noopener,noreferrer');
        } catch (_) {}
      }
      return;
    }

    // Check if this was a drag (scrolling) rather than a click
    if (mouseDownPos) {
      const dx = Math.abs(e.clientX - mouseDownPos.x);
      const dy = Math.abs(e.clientY - mouseDownPos.y);
      if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
        // User was dragging/scrolling, not clicking
        mouseDownPos = null;
        return;
      }
    }
    mouseDownPos = null;

    const link = e.target.closest('a.product-card-widget[href*="/products/"]') ||
                 e.target.closest('a[href*="/products/"]');

    if (!link) return;

    // On mobile, block product card clicks entirely (no modal, no page)
    if (window.innerWidth <= 768) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    const href = link.getAttribute('href') || '';
    const parts = href.split('?')[0].replace(/\/$/, '').split('/');
    const handle = parts[parts.length - 1];
    if (!handle || handle === 'products') return;

    e.preventDefault();
    e.stopPropagation();
    // Capture context for better recommendations (collection + product type)
    const collectionHandles = (link.getAttribute('data-bf-collections') || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
    const productType = (link.getAttribute('data-bf-product-type') || '').trim();
    openProductModal(handle, { collectionHandles, productType });
  }, true);

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-bf-modal-close]')) {
      e.preventDefault();
      closeModalShell();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModalShell();
  });

  if (recsPrev && recsNext && recsContainer) {
    const scrollByAmount = () => Math.max(240, Math.floor(recsContainer.clientWidth * 0.7));
    recsPrev.addEventListener('click', (e) => {
      e.preventDefault();
      if (recsContainer.scrollWidth <= recsContainer.clientWidth + 2) return;
      recsContainer.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
      setTimeout(updateRecsArrows, 220);
    });
    recsNext.addEventListener('click', (e) => {
      e.preventDefault();
      if (recsContainer.scrollWidth <= recsContainer.clientWidth + 2) return;
      recsContainer.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
      setTimeout(updateRecsArrows, 220);
    });
    recsContainer.addEventListener('scroll', updateRecsArrows);
    window.addEventListener('resize', () => requestAnimationFrame(updateRecsArrows));
  }

  qtyMinus.addEventListener('click', (e) => {
    e.stopPropagation();
    const val = parseInt(qtyInput.value);
    if (val > 1) qtyInput.value = val - 1;
  });
  qtyPlus.addEventListener('click', (e) => {
    e.stopPropagation();
    qtyInput.value = parseInt(qtyInput.value) + 1;
  });
  qtyInput.addEventListener('click', (e) => e.stopPropagation());

  addToCartBtn.addEventListener('click', async (e) => {
    e.stopPropagation();
    if (!currentVariantId) return;

    addToCartBtn.disabled = true;
    const originalText = addToCartBtn.textContent;
    addToCartBtn.textContent = 'Adding...';

    try {
      await addItemToCart(currentVariantId, parseInt(qtyInput.value || '1', 10));
      closeModalShell();
    } catch (error) {
      console.error(error);
    } finally {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = originalText;
    }
  });
});
